<template>
  <div class="fixed top-0 header flex items-center justify-between w-full border-b shadow-md bg-white p-4 md:p-5 md:px-10">
    <div class="w-6/12 md:flex items-center justify-between font-bold">
    <ul class="w-full flex items-center justify-start gap-5 ">
      <li> <vs-button class="w-full font-medium text-sm" type="gradient" color="danger" @click="goBack">Go Back</vs-button> </li>  
      <li>  <p class="text-2xl font-bold"><router-link to="/user"><span style="color: rgb(242, 19, 93)">á</span>ptitude</router-link></p> </li>
      <li class="border-gray-300 border-l-2 pl-5">  <p class="text-xl font-bold">{{videoTitle}} Program</p> </li>
    </ul>
    </div>
  </div>
</template>

<script>
export default {
  emits:['change-component'],
  data(){
    return{
      activeLink: "UserHome",
    }
  },
  mounted(){
    if(this.$route.path.includes('flash-abs')){
      this.$store.dispatch('videoCategory', { category: 'Flash Abs'})
    }
  },
  computed:{
    videoTitle(){
      return this.$store.getters.getVideoCategory;
    }
  },
  methods:{
    changeActiveLink(goTo){
      this.activeLink = goTo;
      window.scrollTo(0, 0);
      this.$emit('change-component', goTo)
    },
    goBack(){
      this.$router.go(-1);
    }

  }
}
</script>

<style lang="stylus">
.header{
  z-index: 99999;
}
</style>